import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '@/App';

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          throw new Error('No session ID found');
        }

        // Exchange session_id for user data and session token
        const response = await fetch(`${API}/auth/oauth/session`, {
          method: 'POST',
          headers: {
            'X-Session-ID': sessionId
          },
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Failed to process OAuth session');
        }

        const data = await response.json();
        
        // Create a plain serializable object for navigation state
        const userData = {
          user_id: data.user.user_id,
          email: data.user.email,
          name: data.user.name,
          picture: data.user.picture,
          is_admin: data.user.is_admin,
          is_artist: data.user.is_artist,
          free_votes_remaining: data.user.free_votes_remaining
        };
        
        // Redirect to dashboard with clean user data
        navigate('/dashboard', { state: { user: userData }, replace: true });
      } catch (error) {
        console.error('OAuth callback error:', error);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p>Completing sign in...</p>
      </div>
    </div>
  );
}

export default AuthCallback;